import React from 'react';
import PropTypes from 'prop-types';
import Lightbox from '../lightbox/lightbox';
import { FSRemoveLightBoxHeader } from './fs_remove_light_box_header';
import { FSRemoveLightBoxContent } from './fs_remove_light_box_content';

function FSRemoveLightBox(props) {
    return (
        <Lightbox
            opened={props.visible}
            onClose={props.onClose}
            additionalClassNames={['fs-remove-light-box__lightbox']}
            headerIcon="icon--wheel-alignment"

        >
            <div className="fs-remove-light-box">
                <FSRemoveLightBoxHeader />
                <FSRemoveLightBoxContent
                    expanded={props.expanded}
                    FSFLightBoxVisible={props.FSFLightBoxVisible}
                    detailModeStation={props.detailModeStation}
                    activeStation={props.activeStation}
                    error={props.error}
                    onExpand={props.onExpand}
                    onRemove={props.onRemove}
                    onAccept={props.onAccept}
                    onClose={props.onClose}
                />
            </div>
        </Lightbox>
    );
}

FSRemoveLightBox.propTypes = {
    visible: PropTypes.bool.isRequired,
    expanded: PropTypes.bool.isRequired,
    FSFLightBoxVisible: PropTypes.bool.isRequired,
    detailModeStation: PropTypes.string,
    activeStation: PropTypes.object,
    error: PropTypes.object,
    onExpand: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    onAccept: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};

export { FSRemoveLightBox };
